import PhoneAndroidIcon from "@mui/icons-material/PhoneAndroid";
import ShieldIcon from "@mui/icons-material/Shield";
import {
  Avatar,
  Box,
  Button,
  Chip,
  Paper,
  Stack,
  Typography,
} from "@mui/material";

import { PhoneNumberSetup } from "components/PhoneNumberSetup";
import { useAuthContext, useDisclosure } from "hooks";

export function MFADisabledState() {
  const phoneSetup = useDisclosure();
  const { refreshUser } = useAuthContext();

  const handlePhoneSetupComplete = () => {
    refreshUser().then(() => {
      phoneSetup.onClose();
    });
  };

  return (
    <Paper variant="outlined" sx={{ p: 3, mt: 2, bgcolor: "grey.50" }}>
      <Stack direction="row" alignItems="center" spacing={1.5} mb={2}>
        <Avatar
          sx={{
            bgcolor: "grey.200",
            color: "grey.500",
            width: 40,
            height: 40,
          }}
        >
          <ShieldIcon />
        </Avatar>
        <Box>
          <Typography variant="subtitle1" fontWeight={500}>
            SMS Authentication
          </Typography>
          <Chip
            label="Disabled"
            color="error"
            size="small"
            variant="outlined"
          />
        </Box>
      </Stack>
      <Typography color="text.secondary" mb={2} maxWidth={560}>
        Add an extra layer of security to your account by enabling multi-factor
        authentication via SMS. We&apos;ll send a verification code to your
        mobile phone whenever you sign in.
      </Typography>
      <Button
        variant="contained"
        color="success"
        onClick={phoneSetup.onOpen}
        startIcon={<PhoneAndroidIcon />}
      >
        Add Phone Number
      </Button>
      <PhoneNumberSetup
        open={phoneSetup.isOpen}
        onClose={phoneSetup.onClose}
        onComplete={handlePhoneSetupComplete}
      />
    </Paper>
  );
}
